/**
 * Initializes Plyr video players on all elements with the `[js-plyr-video-init]` attribute.
 *
 */
export const buildPlyrVideo = () => {
  const elements = document.querySelectorAll("[js-plyr-video-init]");
  elements.forEach((element) => {
    const player = new Plyr(element, {
      controls: [
        "play-large",
        "play",
        "progress",
        "current-time",
        "mute",
        "volume",
        "captions",
        "settings",
        "pip",
        "airplay",
        "fullscreen",
      ],
    });

    setTimeout(function () {
      const backImg = document.querySelector(".video-sec .video-block").dataset
        .imageSrc;
      document.querySelector(
        ".video-block .plyr__poster"
      ).style.backgroundImage = "url(" + backImg + ")";
    }, 2000);
  });
};
